import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "src/redux/store";
import { authTokenKeyName } from "src/utils/configs/authConfig";
import { BASE_URL } from "src/utils/constants";

const tagTypes = [
  "accounts",
  "mode",
  "module",
  "accounts",
  "chapters",
  "expense-category",
  "branches",
  "holiday",
  "inquiry",
  "channel",
  "campaign-group",
  "batches",
  "trainer",
  "communication-method",
  "student",
  "coupon",
  "followup",
  "pay-installment",
  "dashboard",
  "question",
  "inquryLabel",
  "resource",
  "registration-link",
  "teamResources",
  "goal-category",
  "goal",
  "job",
  "testimonial",
  "blog",
  "recording-request",
  "question-category",
  "question-technology",
  "test-question",
  "test-series",
  "test-check",
  "recording-rule",
];

export const apiSlice = createApi({
  reducerPath: "apiSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}`,

    prepareHeaders: (headers, { getState, endpoint }) => {
      const token =
        (getState() as RootState)?.auth?.accessToken ||
        localStorage.getItem(authTokenKeyName);
      if (token) {
        headers.set("x-access-token", token);
      }
      return headers;
    },
  }),
  tagTypes: tagTypes,
  endpoints: () => ({}),
});

export default apiSlice;
